import DomainName, { DomainForSubdomainName } from './domain'

/**
 * @module routing
 * @category client
 */

/**
 * Redirects the user back to the login page with a specific license or redirect URL.
 *
 * @memberof module:routing
 * @param {string} toPath - The path to redirect to after logging in.
 * @param {string|undefined} license - A string representing the license Id or undefined, if the redirect URL needs to be set.
 */
export const goBackToLogin = (toPath, license) => {
  if (license) { window.location.href = `${window.location.protocol}//account.${DomainName}/license` } else { window.location.href = `${window.location.protocol}//account.${DomainName}?redirect_url=${window.location.origin}${toPath}` }
}

/**
 * Redirects the user to a specific URL.
 *
 * @memberof module:routing
 * @param {string} redirectUrl - The URL to redirect to.
 * @param {boolean} [useSubdomain=false] - Whether to use the subdomain or not.
 */
export const redirect = (redirectUrl, useSubdomain = false) => {
  if (redirectUrl) window.location.href = redirectUrl
  else window.location.href = `${window.location.protocol}//play.${useSubdomain ? DomainForSubdomainName : DomainName}/dashboard/#/missions///`
}
